interface CounterBadgeProps {
  value: number;
}

export const CounterBadge = ({ value }: CounterBadgeProps) => (
  <span className="fs-200 flex h-7.5 min-w-7.5 items-center justify-center rounded-full bg-neutral-200/7 px-2 text-white">
    {value}
  </span>
);
